export default {
  breakfast: "صبحانه",
  snackAfterBreakfast: "میان وعده بعد از صبحانه",
  lunch: "ناهار",
  snackAfterLunch: "میان وعده بعد از ناهار",
  dinner: "شام",
  snackAfterDinner: "میان وعده بعد از شام",
};
